import { useNavigate, useParams } from 'react-router-dom';
import React, { useContext, useMemo, useEffect } from 'react';
import { RacingsContext } from '@racings/store/context';
import Loader from '@common/components/loader';

import { asyncWrapper } from '@common/hocs/asyncWrapper';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { useDataFetch } from '@common/hooks/dataFetch';
import { SportTypesIds, SportTypesUrlIds } from '@racings/constants/enums/sportTypes';
import { ascAlphabeticalSort } from '@common/helpers/declarative/sortings';
import { listFilter, racingsListGroupedFromResults } from '../helper/resultSelector';
import RacingResultItem from './racingResultItem';
import { useOutletContext } from 'react-router';

export const RacingsResultList = asyncWrapper(({ routePrefix }) => {
  const navigate = useNavigate();
  const { sportType, regionAlias } = useParams();
  const [{ isYesterday, resultData }, setRacingsState] = useContext(RacingsContext);
 const [searchText] = useOutletContext();

  const activeSportId = SportTypesUrlIds[sportType] || SportTypesIds.HORSE;

  const req = useMemo(() => ({
    is_yesterday: isYesterday,
    sport_id: activeSportId,
  }), [activeSportId, isYesterday]);

  const [_data, loading] = useDataFetch(() => (!resultData[isYesterday ? 'yesterday' : 'today'] ? swarmRequest(req, 'get_racing_matches') : null), [req, resultData, isYesterday]);

  const data = resultData || _data;

  const results = resultData[isYesterday ? 'yesterday' : 'today']?.details || data?.details;

  const groupedData = useMemo(() => racingsListGroupedFromResults(results), [results]);

  const racingsResultListFiltered = useMemo(() => (
    listFilter(searchText, regionAlias, groupedData)
  ), [searchText, groupedData, regionAlias]);

  useEffect(() => {
    if (_data) {
      setRacingsState((old) => ({
        ...old,
        resultData: { ...old.resultData, [isYesterday ? 'yesterday' : 'today']: _data },
      }));
    }
    return () => {
      if (!_data) {
        return null;
      }
    };
  }, [_data, isYesterday, setRacingsState]);

  const onSelectGame = (e, regAlias, regionid, compId, gameId) => {
    e.stopPropagation();
    navigate(`${routePrefix}/racings/${sportType}/result/${regAlias}/${compId}/${gameId}`);
  };

  if (loading) return <Loader />;

  return (
    <div className="racings-list-container">
      {racingsResultListFiltered.sort(ascAlphabeticalSort('name')).map((region) => (
        <RacingResultItem
          alwaysOpen={racingsResultListFiltered.length === 1}
          key={region.id}
          region={region}
          search={searchText}
          sportType={sportType}
          onSelectGame={onSelectGame}
          routePrefix={routePrefix}
        />
      ))}
    </div>
  );
});
